import styled from 'styled-components';
import { colorGrey400 } from 'styles';

export const WrapperUpdate = styled.div`
  display: flex;
  align-items: center;
  font-size: 13px;
  line-height: 16px;
  color: ${colorGrey400};
  margin-bottom: 8px;
  white-space: nowrap;

  svg {
    margin: 0 5px 1px 0;
  }
`;

export default WrapperUpdate;
